var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[[_c('v-data-table',{attrs:{"dense":"","headers":_vm.headers,"items":_vm.events,"search":_vm.search,"item-key":"id"},scopedSlots:_vm._u([{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_c('v-icon',{staticClass:"mr-2",attrs:{"small":""},on:{"click":function($event){return _vm.view(item)}}},[_vm._v(" mdi-eye ")])]}}])})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }